// extracted by mini-css-extract-plugin
export default {"container":"tags-filter_container__dYlfd"};